export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./item-list.vue?vue&type=template&id=6aae6b3f&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/item-list.vue?vue&type=template&id=6aae6b3f&scoped=true
// module id = GpPe
// module chunks = 0